import React from 'react';
import { useAuth } from '../../state/auth/useAuth';

export default function RoleGuard({ allowed = [], children }) {
  const { user, loading } = useAuth();
  if (loading) return null; // Optionally a spinner
  if (!user || !allowed.includes(user.role)) return null;
  return children;
}
